import { Directive, TemplateRef, input } from '@angular/core';

@Directive({
	selector: 'ng-template[aePgtStateLoading]',
})
export class PaginationTableStateLoadingDirective {
	readonly disabled = input(false);

	constructor(public template: TemplateRef<any>) {}
}
